import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { CoreEnum } from 'src/app/enums/core.enum';
import { RouteId } from 'src/app/enums/env/routes-id-enum';
import { DateKey } from 'src/app/enums/search-key.enum';
import { SortTicketFieldName } from 'src/app/enums/tickets/ticket-sort-field-name';
import { FilterValue } from 'src/app/interfaces/filtres/filter-interface';
import { DisplayText } from 'src/app/models/events/displayText';
import { EventsAction } from 'src/app/models/events/eventsAction';
import { EventsActionFilters } from 'src/app/models/events/eventsActionFilters';
import { SearchService } from 'src/app/modules/search/services/search.service';
import { PreselectionDatePickerType } from 'src/app/tinea-components/dateTime-picker/component/enums/preselection-date-picker-type';
import { DateStartEndModel } from 'src/app/tinea-components/dateTime-picker/models/datesStartEndModel';
import { TableConfiguration } from 'src/app/tinea-components/tinea-table/models/tableConfiguration';
import { MatchingType } from 'src/swagger-gen/web-secured/models';
import { EventEmitterFilters } from '../../models/table/event-emitter-filters';
import FiltersConfig, {
  FilterConfigRefresh,
} from '../../models/table/filters-config';

@Component({
    selector: 'app-filters-table',
    templateUrl: './filters-table.component.html',
    styleUrls: ['./filters-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FiltersTableComponent implements OnInit {
  @Input() config: FiltersConfig;
  @Input() isLoadingExport: boolean;
  @Input() isAlarme: boolean;
  @Input() configuredPreselectionId: PreselectionDatePickerType =
    PreselectionDatePickerType.LASTWEEK;
  @Output() eventEmitter = new EventEmitter<any>();
  @Output() unSelect = new EventEmitter<any>();
  @Input() defaultGroup: DisplayText;
  @Input() displayUnselect: boolean;
  @Input() hidefilterAll: boolean;
  @Input() newItemFilter: EventsActionFilters;
  @Input() filterType: MatchingType;
  @Input() filtersList: any[];


  groupTableConfiguration: TableConfiguration;
  startDateFilter: string;
  endDateFilter: string;
  currentRefresh: moment.Moment;

  eventsAction: EventsAction = new EventsAction();
  fullColumnList: any;
  displayedColumnDefault: any;
  dataForChildComponent: any = {};
  toltalItems: number;
  groupToltalItems: number;
  groupEnabled = false;
  viewType: 'grid' | 'list';

  constructor(private translate: TranslateService,
    public logger: NGXLogger, ) {}

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: { target: Element }): void {
    if (event.target) {
      const target = event.target as Element;
      const hasParentWithZone = target.closest('.action-filters');
      if (!hasParentWithZone) {
        const elements = document.getElementsByClassName(
          'action-filter-content'
        ) as HTMLCollectionOf<HTMLElement>;
        for (let i = 0; i < elements.length; i++) {
          elements[i].classList.remove('action-filter-content-active');
          elements[i].previousElementSibling.classList.remove(
            'filter-selected'
          );
        }
      }
    }
  }

  ngOnInit(): void {
    if (!!this.newItemFilter && Object.keys(this.newItemFilter).length > 0) {
      // this.loggerService.trace('this.newItemFilter', this.newItemFilter);
      this.eventsAction.filter.addFilterItem(this.newItemFilter);
      this.eventsAction.filter.term = this.newItemFilter.value;
      this.eventsAction.filter.value = this.newItemFilter.field;
      // this.loggerService.trace('this.newItemFilter eventsAction.filter', this.eventsAction.filter);
    }

    // for tickets table, TODO: refactor for make it reusable for other tables if needed
    if (this.filtersList?.length > 0) {
      this.filtersList.forEach (f => {
        const newFilter: EventsActionFilters = new EventsActionFilters();
        // todo: not only for tickets
        const fieldValue = this.translate.instant(`tickets.${f.field.toLowerCase()}`);
        // this.loggerService.trace('fieldValue', fieldValue);
        newFilter.field = { 'key': f.field, 'value': fieldValue };
        newFilter.value = f.value;
        // this.loggerService.trace('newFilter', newFilter);

        this.eventsAction.filter.addFilterItem(newFilter);
        this.eventsAction.filter.term = newFilter.value;
        this.eventsAction.filter.value = newFilter.field;
        // this.loggerService.trace('eventsAction.filter', this.eventsAction.filter);
      });
    }

    this.initActions();
    if (!this.config.date) {
      this.getParamsForRequest();
    }
    this.getBodyForRequest();

    setTimeout(() => {
      this.onChangeGroupOnLoad();
    }, 500);
  }

  initActions() {
    this.fullColumnList = this.config.column?.fullColumnList;
    this.displayedColumnDefault = this.fullColumnList?.filter(
      (c) => c.isDefault === true
    );
    this.eventsAction.setFullColumnList(this.fullColumnList);
    this.eventsAction.setDisplayedColumnList(this.displayedColumnDefault);

    if (this.config.sort) {
      this.eventsAction.sort.order = 'DESC';
      this.eventsAction.sort.column = this.fullColumnList?.find(
        (e: { column: { key: string } }) =>
          e.column.key === this.config.sort.defaultSort
      ).column;
    }

    if (this.config.refresh?.length > 0) {
      const found = this.config.refresh.find(f => f.id === 'refresh');
      if (found?.defaultValue) {
        this.currentRefresh = found.defaultValue;
        this.eventsAction.dataRefresh = {
          date: this.currentRefresh,
          id: 'refresh'
        };
      }
    }

    this.eventsAction.group = new DisplayText(null, 'Aucun');
    this.eventsAction.customFilter.value = new DisplayText('ALL', 'Tout');

    if (!this.hidefilterAll) {
      this.eventsAction.filter.value = new DisplayText('ALL', 'Tout');
    } else {
      if (this.fullColumnList?.length > 0) {
        this.eventsAction.filter.value = new DisplayText(this.fullColumnList[0].column.key, this.fullColumnList[0].column.value);
      }
    }

    // if search without sort
    if (!this.config.column?.fullColumnList && this.config.search?.paramsToInclude) {
      this.eventsAction.filter.value = new DisplayText(this.config.search?.paramsToInclude[0], this.config.search?.paramsToInclude[0]);
    }

    this.viewType = this.config?.view?.type || null;
  }

  /******************* FILTERS DATA ACTIONS *********************/
  getDatesFromFilter(dates: DateStartEndModel) {
    this.startDateFilter = dates.dateStart;
    this.endDateFilter = dates.dateEnd;
    this.getParamsForRequest();
  }

  getParamsForRequest(): void {
    const params = [];
    if (this.config.date) {
      params.push({ key: 'startDateTime', value: this.startDateFilter });
      params.push({ key: 'endDateTime', value: this.endDateFilter });
    }
    if (this.config.sort) {
      params.push({
        key: 'sortFieldName',
        value: this.eventsAction.sort.column.key,
      });
      params.push({
        key: 'sortDirection',
        value: this.eventsAction.sort.order,
      });
    }
    if (this.config.group) {
      if (this.eventsAction.group.key) {
        this.groupEnabled = true;
        params.push({ key: 'groupName', value: this.eventsAction.group.key });
      } else {
        this.groupEnabled = false;
      }
    }

    this.eventEmitter.next({
      type: EventEmitterFilters.PARAMS,
      data: params,
    });
  }

  getBodyForRequest(): void {
    const filters = this.eventsAction.filter.filters;
    const body = {
      filters: [],
    };
    if (filters.length > 0) {
      filters.forEach((f) => {
        if (f.field.key === SortTicketFieldName.STATION_NAME) {
          body.filters.push({
            field: f.field.key,
            value: f.value,
            matchingType: MatchingType.PARTIAL_MATCH_IGNORE_CASE,
          });
        } else {
          body.filters.push({
            field: f.field.key,
            value: f.value,
            matchingType: this.filterType || CoreEnum.DEFAULT_MATCHING_TYPE,
          });
        }
      });
    }
    const customFilters = this.eventsAction.customFilter.filters;
    if (customFilters) {
      customFilters.forEach((cf) => {
        if (cf.field.key !== 'ALL') {
          body.filters.push({
            field: cf.field.key,
            value: cf.value,
            matchingType: this.filterType || MatchingType.EXACT_MATCH,
          });
        }
      });
    }
    this.eventEmitter.next({
      type: EventEmitterFilters.BODY,
      data: body,
    });
  }

  /******************* FILTERS ACTIONS *********************/
  onActionFilterBtnToggle(target) {
    const classForSelectedBtn = 'filter-selected';
    const classForDisplayPopup = 'action-filter-content-active';
    const classForDisplaySelectOptions = 'show';
    const btn: Element = target;
    const popup = btn.nextElementSibling;
    const parent = btn.parentElement.parentElement;
    const isActive = btn.classList.contains(classForSelectedBtn);

    const children = parent.children;
    for (let i = 0; i < parent.children.length; i++) {
      const child = children[i];
      const childBtn = child.firstElementChild;
      const childPopup = childBtn.nextElementSibling;
      childBtn.classList.remove(classForSelectedBtn);
      if (childPopup) {
        childPopup.classList.remove(classForDisplayPopup);
      }
    }

    const items = document.querySelectorAll('.' + classForDisplaySelectOptions);
    items.forEach((e) => e.classList.remove(classForDisplaySelectOptions));

    if (isActive) {
      btn.classList.remove(classForSelectedBtn);
      popup.classList.remove(classForDisplayPopup);
    } else {
      btn.classList.add(classForSelectedBtn);
      popup.classList.add(classForDisplayPopup);
    }
  }

  togglePlusContent(
    target: Element,
    popupTarget: 'next' | 'parent' | 'parent-parent' | 'parent-next'
  ) {
    const btn: Element = target;
    let popup;
    switch (popupTarget) {
      case 'next':
        popup = btn.nextElementSibling;
        break;
      case 'parent-next':
        popup = btn.parentElement.nextElementSibling;
        break;
      case 'parent-parent':
        popup = btn.parentElement.parentElement;
        break;
      case 'parent':
        popup = btn.parentElement;
        break;
    }
    if (popup) {
      const classForDisplayPopup = 'show';
      const isActive = popup.classList.contains(classForDisplayPopup);

      if (isActive) {
        popup.classList.remove(classForDisplayPopup);
      } else {
        popup.classList.add(classForDisplayPopup);
      }
    }
  }

  // Column Filters
  addColumnItem(columnKey: string): void {
    this.eventsAction.columns.addDisplayedColumnList(columnKey);
    this.eventEmitter.next({
      type: EventEmitterFilters.SHOW_HIDE_COLUMN,
      data: {
        columnKey: columnKey,
        show: true,
      },
    });
  }

  removeColumnItem(columnKey: string): void {
    this.eventsAction.columns.removeDisplayedColumnList(columnKey);
    this.eventEmitter.next({
      type: EventEmitterFilters.SHOW_HIDE_COLUMN,
      data: {
        columnKey: columnKey,
        show: false,
      },
    });
  }

  onChangeSortColumn(column: DisplayText, target) {
    this.eventsAction.sort.column = column;
    this.togglePlusContent(target, 'parent-parent');
  }
  // Column Filters Ends

  // Sort Filters
  onChangeSortOrder(order: 'ASC' | 'DESC', target) {
    this.eventsAction.sort.order = order;
    this.togglePlusContent(target, 'parent-parent');
  }

  onChangeSort(target) {
    const btnAction: Element = target;
    const btnFilter =
      btnAction.parentElement.parentElement.previousElementSibling;
    this.onActionFilterBtnToggle(btnFilter);
    this.getParamsForRequest();
  }

  onChangeCustomFilter(chosenCustomFilter: EventsActionFilters, target) {
    this.eventsAction.customFilter.value = chosenCustomFilter.field;
    this.eventsAction.customFilter.filters = [...[chosenCustomFilter]];
    this.togglePlusContent(target, 'parent-parent');
  }

  onChangeGroupOnLoad() {
    if (this.defaultGroup) {
      const group = this.defaultGroup;
      const target = document.querySelector('[data-group-key="' + group.key + '"]');
      const btn = document.querySelector('.btn-group-validation');
      this.onChangeGroup(group, target);
      this.onGroupValidation(btn);
      this.onActionFilterBtnToggle(btn.parentElement.parentElement.previousElementSibling);
    }

  }

  onChangeGroup(group: DisplayText, target) {
    this.eventsAction.group = group;
    this.togglePlusContent(target, 'parent-parent');
  }

  onGroupValidation(target) {
    const btnAction: Element = target;
    const btnFilter =
      btnAction.parentElement.parentElement.previousElementSibling;
    this.onActionFilterBtnToggle(btnFilter);
    this.getParamsForRequest();
  }

  onChangeFilterSelect(value: DisplayText, target) {
    this.eventsAction.filter.value = value;
    this.togglePlusContent(target, 'parent-parent');
  }

  onChangeFilterTerm(event) {
    const value = event.target.value;
    this.eventsAction.filter.term = value;
  }

  onPressEnterInSearch(event: any) {
    event.preventDefault();

    const btn: Element = event.target.nextElementSibling.nextElementSibling;
    this.addFilterItem(btn);
  }

  onCustomFilterValidation() {
    const newItemFilter = new EventsActionFilters();
    newItemFilter.field = this.eventsAction.customFilter.value;
    if (this.eventsAction.customFilter.filters[0]) {
      newItemFilter.value = this.eventsAction.customFilter.filters[0].value;
      this.eventsAction.customFilter.addFilterItem(newItemFilter);
      this.getBodyForRequest();
    }
  }

  addFilterItem(target): void {
    if (this.eventsAction.filter.term !== null) {
      const btn = target;
      const newItemFilter = new EventsActionFilters();
      newItemFilter.field = this.eventsAction.filter.value;
      newItemFilter.value = this.eventsAction.filter.term;
      this.eventsAction.filter.addFilterItem(newItemFilter);
      this.getBodyForRequest();

      const input = btn.previousElementSibling.previousElementSibling;
      input.value = '';
      this.eventsAction.filter.term = null;
    }
  }

  removeFilterItem(field: EventsActionFilters): void {
    this.eventsAction.filter.removeFilterItem(field);
    this.getBodyForRequest();
  }

  OnUnselect(event: any) {
    this.unSelect.emit();
  }

  exportData() {
    this.eventEmitter.next({
      type: EventEmitterFilters.EXPORT,
    });
  }

  onClickView() {
    this.toggleView();
    this.eventEmitter.next({
      type: EventEmitterFilters.VIEW,
      data: this.viewType
    });
  }

  onClickRefresh(item: FilterConfigRefresh) {
    if (item.id === 'refresh') {
      this.currentRefresh = moment();
    } else if (item.id === 'update') {
    }
    this.eventsAction.dataRefresh = {
      date: this.currentRefresh,
      id: item.id
    };

    this.eventEmitter.next({
      type: EventEmitterFilters.REFRESH,
      data: this.eventsAction.dataRefresh
    });

  }

  toggleView() {
    this.viewType = this.viewType === 'grid' ? 'list' : 'grid';
  }
}
